export enum TriState {
  Yes = "Yes",
  No = "No",
  NotSpecified = "NotSpecified",
}